<template>
    <div :class="`title-align-${localTitleAlign} title`">
        <h3 :class="`h1-size-${localTitleSize}`" @click="focusTitle" v-if="!editingTitle">{{ displayTitleText }}</h3>
        <input
            v-if="editingTitle"
            type="text"
            :class="`h1-size-${localTitleSize} title-input main-title-input`"
            placeholder="Başlık"
            v-model="localTitleText"
            @blur="stopEditingTitle"
            @keydown.enter="stopEditingTitle"
            ref="titleInput"
        />
        <h5 :class="`h3-size-${localTitleSize}`" @click="focusSubTitle"
            v-if="!editingSubTitle && (localSubTitle || !editingTitle)">{{ displaySubTitle }}</h5>
        <input
            v-if="editingSubTitle"
            type="text"
            :class="`h3-size-${localTitleSize} title-input sub-title-input`"
            placeholder="Bir alt başlık yazın"
            v-model="localSubTitle"
            @blur="stopEditingSubTitle"
            @keydown.enter="stopEditingSubTitle"
            ref="subTitleInput"
        />
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormTitle",
    props: {
        item: Object,
        titleSize: String,
        titleAlign: String,
        titleText: String,
        subTitle: String,
    },
    data() {
        return {
            localTitleText: this.titleText || "",
            localSubTitle: this.subTitle || "",
            localTitleSize: this.titleSize || "default",
            localTitleAlign: this.titleAlign || "center",
            editingTitle: false,
            editingSubTitle: false,
            updateTimer: null,
        };
    },
    computed: {
        displayTitleText() {
            return this.localTitleText || "Başlık";
        },
        displaySubTitle() {
            return this.localSubTitle || "Alt Başlık";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        focusTitle() {
            this.editingTitle = true;
            this.$nextTick(() => {
                if (this.$refs.titleInput) {
                    this.$refs.titleInput.focus();
                }
            });
        },
        focusSubTitle() {
            this.editingSubTitle = true;
            this.$nextTick(() => {
                if (this.$refs.subTitleInput) {
                    this.$refs.subTitleInput.focus();
                }
            });
        },
        stopEditingTitle() {
            this.editingTitle = false;
            this.updateField();
        },
        stopEditingSubTitle() {
            this.editingSubTitle = false;
            this.updateField();
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
            const updateFields = {
                    label: self.localTitleText,
                    slug: self.item.slug,
                title: {
                        titleText: self.localTitleText,
                        subTitle: self.localSubTitle,
                        titleSize: self.localTitleSize,
                        titleAlign: self.localTitleAlign,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                updateFields: updateFields,
            });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        titleText(newVal) {
            this.localTitleText = newVal;
        },
        subTitle(newVal) {
            this.localSubTitle = newVal;
        },
        titleSize(newVal) {
            this.localTitleSize = newVal;
        },
        titleAlign(newVal) {
            this.localTitleAlign = newVal;
        },
    },
};
</script>
<style lang="scss" scoped>
// Alignment Classes
.title-align-center {
    text-align: center !important;
}

.title-align-right {
    text-align: right !important;
}

.title-align-left {
    text-align: left !important;
}

// Size Classes for Main Title (h3)
.h1-size-wide {
    font-size: clamp(1.75rem, 4vw, 2.25rem) !important;
    font-weight: 700 !important;
    letter-spacing: -0.025em !important;
}

.h1-size-small {
    font-size: clamp(1.25rem, 3vw, 1.5rem) !important;
    font-weight: 600 !important;
    letter-spacing: -0.015em !important;
}

.h1-size-default {
    font-size: clamp(1.5rem, 3.5vw, 1.75rem) !important;
    font-weight: 650 !important;
    letter-spacing: -0.02em !important;
}

// Size Classes for Subtitle (h5)
.h3-size-wide {
    font-size: clamp(1.125rem, 2.5vw, 1.25rem) !important;
    font-weight: 500 !important;
    letter-spacing: 0.01em !important;
}

.h3-size-small {
    font-size: clamp(0.9rem, 2vw, 1rem) !important;
    font-weight: 450 !important;
    letter-spacing: 0.005em !important;
}

.h3-size-default {
    font-size: clamp(1rem, 2.25vw, 1.125rem) !important;
    font-weight: 475 !important;
    letter-spacing: 0.008em !important;
}

.title {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.75rem, 2vw, 1.25rem) auto;
    text-align: left;
    position: relative;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);


    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;


    border: 1px solid rgba(255, 255, 255, 0.08);

    
    &:hover {
        background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.04) 0%,
            rgba(255, 255, 255, 0.02) 100%);
        transform: translateY(-1px);
    }

    h3 {
        margin-bottom: clamp(0.375rem, 1vw, 0.5rem);
        color: var(--text-primary, rgba(55, 65, 81, 0.95));
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        line-height: 1.3;
        transition: all 0.3s ease;
        position: relative;
        cursor: pointer;
            border: none;
            background: transparent;
            outline: none;
        width: 100%;
        padding: 0;
    }

    // Ana başlık input'ları için basit CSS
    .main-title-input {
        display: block !important;
        width: 100% !important;
        margin-bottom: clamp(0.375rem, 1vw, 0.5rem) !important;
        padding: 12px 16px !important;
        border: 2px solid #f26a52 !important;
        border-radius: 8px !important;
        background: rgba(255, 255, 255, 0.9) !important;
        color: rgba(55, 65, 81, 0.95) !important;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
        font-size: clamp(1.5rem, 3.5vw, 1.75rem) !important;
        font-weight: 650 !important;
        line-height: 1.3 !important;
        outline: none !important;
        box-shadow: 0 2px 8px rgba(242, 106, 82, 0.2) !important;
        transition: all 0.3s ease !important;

    }
    
    .main-title-input:focus {
        border-color: #e55a42 !important;
        background: rgba(255, 255, 255, 1) !important;
        box-shadow: 0 4px 12px rgba(242, 106, 82, 0.3) !important;
    }

    .main-title-input::placeholder {
        color: rgba(156, 163, 175, 0.7) !important;
        font-style: italic !important;
    }

    h5 {
        color: var(--text-secondary, rgba(107, 114, 128, 0.8));
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        line-height: 1.5;
        margin-top: clamp(0.25rem, 0.5vw, 0.375rem);
        opacity: 0.85;
        transition: all 0.3s ease;
        position: relative;
        cursor: pointer;
        border: none;
        background: transparent;
        outline: none;
        width: 100%;
        padding: 0;
    }

    // Alt başlık input'ları için basit CSS
    .sub-title-input {
        display: block !important;
        width: 100% !important;
        margin-top: clamp(0.25rem, 0.5vw, 0.375rem) !important;
        padding: 10px 14px !important;
        border: 2px solid rgba(242, 106, 82, 0.4) !important;
        border-radius: 6px !important;
        background: rgba(255, 255, 255, 0.8) !important;
        color: rgba(107, 114, 128, 0.9) !important;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
        font-size: clamp(1rem, 2.25vw, 1.125rem) !important;
        font-weight: 475 !important;
        line-height: 1.5 !important;
        outline: none !important;
        box-shadow: 0 1px 6px rgba(242, 106, 82, 0.15) !important;
        transition: all 0.3s ease !important;

    }
    
    .sub-title-input:focus {
        border-color: #f26a52 !important;
        background: rgba(255, 255, 255, 0.95) !important;
        box-shadow: 0 2px 10px rgba(242, 106, 82, 0.25) !important;
    }

    .sub-title-input::placeholder {
        color: rgba(156, 163, 175, 0.6) !important;
        font-style: italic !important;
    }

    // Genel input styling - her durumda çalışması için
    .title input[type="text"] {
        display: block !important;
        width: 100% !important;
        border: 2px solid #f26a52 !important;
        border-radius: 6px !important;
        background: rgba(255, 255, 255, 0.9) !important;
        outline: none !important;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
        transition: all 0.3s ease !important;
    }
    
    .title input[type="text"]:focus {
        background: rgba(255, 255, 255, 1) !important;
        box-shadow: 0 2px 8px rgba(242, 106, 82, 0.2) !important;
    }

    // Hover effects for text
    &:hover {
        h3 {
            color: var(--text-primary, rgba(55, 65, 81, 1));
        }

        h5 {
            opacity: 1;
            color: var(--text-secondary, rgba(107, 114, 128, 0.9));
        }
    }

    // Responsive Design
    @media (max-width: 768px) {
        width: 100%;
        margin: clamp(0.5rem, 1.5vw, 0.75rem) auto;
        padding: clamp(0.75rem, 2vw, 1rem) clamp(0.5rem, 1.5vw, 0.75rem);
        border-radius: 0.5rem;

        h3 {
            margin-bottom: clamp(0.25rem, 0.75vw, 0.375rem);
        }

        input[type="text"].h1-size-wide, input[type="text"].h1-size-small, input[type="text"].h1-size-default {
            margin-bottom: clamp(0.25rem, 0.75vw, 0.375rem);
            padding: clamp(8px, 1.5vw, 10px) clamp(10px, 2vw, 12px);
            border-radius: 0.375rem;
            
            &:hover {
                transform: none;
            }
        }

        h5 {
            margin-top: clamp(0.125rem, 0.375vw, 0.25rem);
        }

        input[type="text"].h3-size-wide, input[type="text"].h3-size-small, input[type="text"].h3-size-default {
            margin-top: clamp(0.125rem, 0.375vw, 0.25rem);
            padding: clamp(6px, 1.2vw, 8px) clamp(8px, 1.5vw, 10px);
            border-radius: 0.25rem;
            
            &:hover {
                transform: none;
            }
        }
    }

    @media (max-width: 480px) {
        width: 100%;
        padding: clamp(0.5rem, 1.5vw, 0.75rem) clamp(0.375rem, 1vw, 0.5rem);
        margin: clamp(0.375rem, 1vw, 0.5rem) auto;
        border-radius: 0.375rem;

        &:hover {
            transform: none;
        }
    }
}

// Reduced Motion Support
@media (prefers-reduced-motion: reduce) {
    .title {
        transition: none;

        &:hover {
            transform: none;
        }

        h3, h5 {
            transition: none;
        }

        input[type="text"] {
            transition: none;
            
            &:hover {
                transform: none;
        }

            &:focus {
                transform: none;
            }
        }
    }
}
</style>


